import React, { Component } from 'react';
import $ from "jquery";
import PdfViewer from './PdfViewer';

class ReportOperationsModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#reportOperationsModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };


    render() {
        const {
            ReportsModel,
            ActualDate,
            ChangeInitialDate,
            ChangeFinalDate,
            ListEmployee,
            ListItmsGrpCod,
            ChangeCondition,
            ChangeAmount,
            EventCheckboxVendor,
            EventCheckboxLines,
            GenerateReportOperationsVendor,
            ShowPDFViewerModal,
            ListReports,
            ShowPDFViewer,
            checkboxLines,
            checkboxVendor,
            MailTools,
            sucursales,
            ChangeSucursal,
            printhide,
            ShowFormatToPrint,
        } = this.props;

        ListEmployee.sort((a, b) => (a.SlpCode > b.SlpCode) ? 1 : ((b.SlpCode > a.SlpCode) ? -1 : 0));
        ListItmsGrpCod.sort((a, b) => (a.ItmsGrpNam > b.ItmsGrpNam) ? 1 : ((b.ItmsGrpNam > a.ItmsGrpNam) ? -1 : 0));

        return (
            <div className="modal fade" id="reportOperationsModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="reportOperationsModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-xl modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343a40" }}>
                            <h5 style={{ color: "white" }}>Operaciones por Vendedor</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="mt-2">

                                <div className='row'>

                                    <div className='col-12 col-md-6'>
                                        <div className='row'>
                                            <div className='col-12 col-md-12'>
                                                <div className="input-group mt-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Desde: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date" className="form-control"
                                                        max={ActualDate}
                                                        value={ReportsModel.InitialDate}
                                                        onChange={(event) => ChangeInitialDate(event)}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-12'>
                                                <div className="input-group mt-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Hasta: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date" className="form-control"
                                                        max={ActualDate}
                                                        value={ReportsModel.FinalDate}
                                                        onChange={(event) => ChangeFinalDate(event)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-12 col-md-12'>
                                                <div className="input-group mt-3">
                                                    <div className='input-group-prepend'>
                                                        <span className='input-group-text'><strong>Monto:</strong></span>
                                                    </div>
                                                    <select
                                                        name="select"
                                                        className="form-control"
                                                        value={ReportsModel.Condition}
                                                        onChange={event => ChangeCondition(event)}
                                                    >
                                                        <option className="text-center" value="<=" style={{ fontWeight: "bold" }}>{"<="}</option>
                                                        <option className="text-center" value=">=" style={{ fontWeight: "bold" }}>{">="}</option>
                                                    </select>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={ReportsModel.Amount}
                                                        onChange={(event) => ChangeAmount(event)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6'>
                                        <div className='row'>
                                            <div className='col-12 col-md-12'>
                                                <div className="input-group mt-3">
                                                    <div className='input-group-prepend'>
                                                        <span className='input-group-text'><strong>Sucursal:</strong></span>
                                                    </div>
                                                    <select
                                                        name="select"
                                                        className="form-control"
                                                        value={ReportsModel.Sucursal}
                                                        onChange={event => ChangeSucursal(event)}
                                                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                    >
                                                        <option value="---">Selecciona</option>
                                                        {!!sucursales && sucursales.map(sucursal => {
                                                            return (
                                                                <option value={sucursal.code}>{`${sucursal.nombre}`}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <span><strong>Departamentos:</strong></span>
                                        <table className='scrollTable'>
                                            <thead style={{ background: "#dee2e6" }}>
                                                <tr>
                                                    <td className='pl-3 pr-3'></td>
                                                    <td>Codigo</td>
                                                    <td>Nombre</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className='text-center'>
                                                        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                    </td>
                                                    <td>0000000</td>
                                                    <td>Nombre</td>
                                                </tr>
                                            </tbody>
                                        </table> */}
                                    </div>
                                </div>
                                <div className='row mt-3'>
                                    <div className='col-12 col-md-6'>
                                        <span><strong>Vendedores:</strong></span>
                                        <div className='scrollTable' style={{ marginBottom: 0, height: 350, maxHeight: 350 }}>
                                            <table>
                                                <thead style={{ background: "#dee2e6" }} className="sticky-header">
                                                    <tr>
                                                        <td className='pl-3 pr-3 text-center'>
                                                            <input
                                                                type="checkbox"
                                                                id="cbox2"
                                                                value="second_checkbox"
                                                                onChange={(event) => EventCheckboxVendor.selectAll(event.target.checked)}
                                                                checked={checkboxVendor}
                                                            />
                                                        </td>
                                                        <td>Codigo</td>
                                                        <td>Nombre</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!!ListEmployee && ListEmployee.map((list, index) => {

                                                        return (
                                                            <tr>
                                                                <td className='text-center'>
                                                                    <input
                                                                        type="checkbox"
                                                                        id={'Chk' + index}
                                                                        checked={list.selected}
                                                                        onChange={() => EventCheckboxVendor.selectOne(index)}
                                                                    />
                                                                </td>
                                                                <td>{list.SlpCode}</td>
                                                                <td>{list.SlpName}</td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className='col-12 col-md-6'>
                                        <span><strong>Lineas:</strong></span>
                                        <div className='scrollTable' style={{ marginBottom: 0, height: 350, maxHeight: 350 }}>
                                            <table>
                                                <thead style={{ background: "#dee2e6" }} className="sticky-header">
                                                    <tr>
                                                        <td className='pl-3 pr-3 text-center'>
                                                            <input
                                                                type="checkbox"
                                                                id="cbox1"
                                                                value="second_checkbox"
                                                                onChange={(event) => EventCheckboxLines.selectAll(event.target.checked)}
                                                                checked={checkboxLines}
                                                            />
                                                        </td>
                                                        <td>Codigo</td>
                                                        <td>Nombre</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!!ListItmsGrpCod && ListItmsGrpCod.map((list, index) => {

                                                        return (
                                                            <tr>
                                                                <td className='text-center'>
                                                                    <input
                                                                        type="checkbox"
                                                                        id={'Chk' + index}
                                                                        checked={list.selected}
                                                                        onChange={() => EventCheckboxLines.selectOne(index)}
                                                                    />
                                                                </td>
                                                                <td>{list.ItmsGrpCod}</td>
                                                                <td>{list.ItmsGrpNam}</td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" >Cancelar</button>
                            <button type="button" className="btn btn-primary" onClick={() => GenerateReportOperationsVendor()}>Generar</button>
                        </div>
                    </div>
                </div>

                {ShowPDFViewerModal &&
                    <PdfViewer
                        DocsToPrint={ListReports}
                        ActualDate={ActualDate}
                        TypeDoc={'ReportOperationVendor'}
                        EnableEditButton={false}
                        Editable={false}
                        ChangeEditableMode={false}
                        EditableDocModel={'SalesTools.EditableDocModel'}
                        RefreshDocModel={'SalesTools.RefreshDocModel'}
                        SaveChanges={'SalesTools.SaveChangesOrderInvoice'}
                        UploadDoc={'SalesTools.UploadInvoice'}
                        EditParam1={false}
                        ShowPDFViewer={ShowPDFViewer}
                        user={'user'}
                        Counter={true}
                        ReportsModel={ReportsModel}
                        MailTools={MailTools}
                        printhide={printhide}
                        ShowFormatToPrint={ShowFormatToPrint}
                        reprint={false}
                    />
                }
            </div>
        );
    }
}

export default ReportOperationsModal;